function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.0002 14.3333C6.73353 14.3333 7.32686 13.74 7.32686 13.0067H4.67353C4.67353 13.74 5.26686 14.3333 6.0002 14.3333ZM11.5269 11.1933L10.6669 10.3333V6.33333C10.6669 4.1 9.09353 2.23333 7.0002 1.78V1C7.0002 0.446667 6.55353 0 6.0002 0C5.44686 0 5.0002 0.446667 5.0002 1V1.78C2.90686 2.23333 1.33353 4.1 1.33353 6.33333V10.3333L0.47353 11.1933C0.0535304 11.6133 0.346864 12.3333 0.940197 12.3333H11.0535C11.6535 12.3333 11.9469 11.6133 11.5269 11.1933ZM6.66686 9.66667H5.33353V8.33333H6.66686V9.66667ZM6.66686 6.33333C6.66686 6.7 6.36686 7 6.0002 7C5.63353 7 5.33353 6.7 5.33353 6.33333V5C5.33353 4.63333 5.63353 4.33333 6.0002 4.33333C6.36686 4.33333 6.66686 4.63333 6.66686 5V6.33333Z",
  fill: "#45505B"
});

var SvgAlertsIcon = function SvgAlertsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 12 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlertsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alerts_icon.b51e001a.svg";
export { ForwardRef as ReactComponent };